import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { NavigationRoute } from 'src/app/core/constants/constants';
import { RegBlobDataTypeEnum, RegWorkflowEnum } from 'src/app/core/dtos/enum';

import { Step } from 'src/app/core/dtos/step';
import { RegWorkflowMappingService } from 'src/app/core/services/reg-workflow-mapping.service';
import { PageStepEnum, StepProgressService } from 'src/app/core/services/step-progress.service';
import { selectRegTestSession } from 'src/app/state/reg-data.selectors';

@Component({
  selector: 'app-photo-upload',
  templateUrl: './photo-upload.component.html',
  styleUrls: ['./photo-upload.component.scss']
})
export class PhotoUploadComponent implements OnInit {

  steps: Step[];
  photoUploaded: boolean;
  pagePath = NavigationRoute.REGISTRATION.photoUpload;
  regWorkFlow: RegWorkflowEnum;
  showPhotoCapture: boolean;

  @ViewChild('content') modalContent: string;

  constructor(
    private modalService: NgbModal,
    private store: Store,
    private regWorkflowMappingService: RegWorkflowMappingService,
    private router: Router,
    private stepProgressService: StepProgressService
  ) {
    this.steps = this.stepProgressService.getSteps(PageStepEnum.Photo);

  }

  public get RegBlobDataTypeEnum() {
    return RegBlobDataTypeEnum;
  }

  ngOnInit(): void {
    this.store.select(selectRegTestSession).pipe(take(1))
      .subscribe(
        (result) => {
          this.regWorkFlow = this.regWorkflowMappingService.getRegWorkFlow(result);
        });
  }

  openModal(showPhotoCapture: boolean) {
    this.showPhotoCapture = showPhotoCapture;
    this.modalService.open(this.modalContent, { size: 'lg' });
  }

  changeStatus() {
    this.photoUploaded = true;
  }

  redirectNextStep() {
    const nextStep = this.regWorkflowMappingService.getNextStepNew(this.regWorkFlow, this.pagePath);
    this.router.navigate([nextStep]);
  }

}


